import { useQuery } from "@apollo/client";
import { useLocation } from "react-router";
import { NEWS_QUERY, TARIFFS_ACTIONS_QUERY } from "Services/queries";
import { useWithDefaultParams } from "Services/useWithDefaultParams";

export const useNewsQuery = () => {
	let match = useWithDefaultParams();
	const location = useLocation();

	let filter = [];
	let filterAggregate = [];
	let limit = 20;

	if (match.params?.regionUrl) {
		filter.push(`region.url=${match.params?.regionUrl}`);
		filterAggregate.push(`region.url=${match.params?.regionUrl}`);
	}

	let page = 1;
	if (match.params?.page) {
		page = match.params?.page;
	}

	filter.push("is_action=1", "provider.mobile_operator=0");
	filterAggregate.push("is_action=1", "provider.mobile_operator=0");

	let getParams1 = location.search.split("?");
	if (getParams1.length > 1) {
		let getParams2 = getParams1[1].split("&");
		getParams2.map((item) => {
			let getParam3 = item.split("=");

			switch (getParam3[0]) {
				case "providers":
					filter.push(`provider.id=${getParam3[1]}`);
					break;
				case "rating":
					filter.push(`rating_type=${getParam3[1]}`);
					break;
				case "service":
					filter.push(`order_type_id=${getParam3[1]}`);
					break;
				default:
					break;
			}
		});
	}
	let withAggregate = 1;

	const newsQuery = useQuery(NEWS_QUERY, {
		variables: {
			limit: limit,
			offset: page > 0 ? limit * (page - 1) : 0,
			filter: filter.join("&"),
			withAggregate: withAggregate,
			aggregateFilter: filterAggregate.join("&"),
		},
	});

	return { data: newsQuery.data?.news ? newsQuery.data : null };
};

export const useTariffsActionsQuery = (currentSort) => {
	const match = useWithDefaultParams();

	const tariffsQuery = useQuery(TARIFFS_ACTIONS_QUERY, {
		variables: {
			region_url: match.params?.regionUrl,
			excludeCard: 3,
			sort: currentSort,
			providerJoin: true,
		},
	});

	const tariffs = (!tariffsQuery.loading && tariffsQuery.data?.tariffsActionsPage?.data) || [];

	return { tariffs, isLoading: tariffsQuery.loading };
};
